import React from 'react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import { moduleActions } from '../../../redux/modules';
import { TRANSACTION_LANDING_SELL_FROM_SWEEP } from '../../../redux/modules/modals/modals.module';
import { getUserSweepAccounts } from '../../../redux/modules/transactionLanding/transactionLanding.selectors';
import Button from '../../Shared/Button/Button';
import RadioButton from '../../Shared/RadioButton/RadioButton';
import { appendBasePath } from '../../../utils/nav.utils';

import './SellFromSweepModal.scss';

class SellFromSweepModal extends React.Component {
  state = {
    selectedSweepAccount: null,
  };

  navigateToSweep() {
    const {
      actions: { closeModal },
    } = this.props;
    const { selectedSweepAccount } = this.state;
    window.location.href = appendBasePath(
      `/sell?reset=true&productType=MutualFund&selectedAgreementIDs=${selectedSweepAccount}`
    );
    closeModal(TRANSACTION_LANDING_SELL_FROM_SWEEP);
  }

  selectSweepAccount(agreementID) {
    this.setState({ selectedSweepAccount: agreementID });
  }

  render() {
    const {
      actions: { closeModal },
      userSweepAccounts,
    } = this.props;
    const { selectedSweepAccount } = this.state;
    return (
      <div className="sell-from-sweep-modal-container">
        <div className="sell-from-sweep-modal-radio-container">
          <p className="e2e-modal-title sell-from-sweep-modal-title">
            Select your Sweep Account from the list below.
          </p>
          {userSweepAccounts.map(
            ({ agreementID, agreementNumber, fundName, ticker }, i) => (
              <div key={`${agreementID}`} className="sell-from-sweep-modal-row">
                <label className="sell-from-sweep-modal-radio-element">
                  <RadioButton
                    ariaLabel={`Choose sweep account ${agreementID}`}
                    category={'sweepAccounSelection'}
                    checked={agreementID === selectedSweepAccount}
                    id={`sweep-account-${i}`}
                    labelText={''}
                    onClick={() => this.selectSweepAccount(agreementID)}
                    stylename="sweep-account-selection-radio"
                    tabIndex={i}
                    value={agreementID}
                  />
                  <div className="sell-from-sweep-modal-radio-label">
                    <span className="sell-from-sweep-modal-fund-name">
                      {fundName}
                    </span>
                    <span className="sell-from-sweep-modal-ticker">
                      {ticker}
                    </span>
                    <div className="sell-from-sweep-modal-agreement-number">
                      {agreementNumber}
                    </div>
                  </div>
                </label>
              </div>
            )
          )}
        </div>

        <div className="sell-from-sweep-modal-button-container">
          <a
            className="college-branded-choice-button"
            id="cancel-sell-from-sweep"
            onClick={() => closeModal(TRANSACTION_LANDING_SELL_FROM_SWEEP)}
          >
            Cancel
          </a>
          <Button
            buttonType="primary"
            className="college-branded-choice-button e2e-sweep-continue"
            disabled={!selectedSweepAccount}
            id="continue-to-sell-from-sweep"
            onClick={() => this.navigateToSweep()}
            stylename="sell-from-sweep-modal-continue-btn"
            type="button"
          >
            Continue
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSweepAccounts: getUserSweepAccounts(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...moduleActions }, dispatch),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SellFromSweepModal
);
